import { BaseModel } from './base.model';
import { Customer } from './customer.model';
import { Marque } from './marque.model';

export type UserType = 'CPP' | 'OPERATOR' | 'CLIENT' | 'ADMIN';

export const USER_LANGUAGES = {
    en: {
        key: 'en',
        label: 'English'
    },
    fr: {
        key: 'fr',
        label: 'Français'
    }
};

export enum UserPermission {
    CPP = 'CPP',
    OPERATOR = 'OPERATOR',
    CLIENT = 'CLIENT',
    ADMIN = 'ADMIN',
    FAB = 'FAB',
    ARCHIVER = 'ARCHIVER',
}

export interface IMinimalUser {
    _id: string;
    username: string;
    firstname: string;
    lastname: string;
    fullname: string;
}

export interface IUser {
    _id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullname: string;
    email: string;
    permissions: any[];
    attributes_name: string[];
    customer?: Customer | null;
    marque?: string;
    marques: string[];
    scope_name?: string[];
    isDiadem: boolean;
    lang: string;
    language?: string;
    populated?: {
        marques: Marque[];
    }
}

export class User extends BaseModel<IUser> implements IUser {
    get isDiadem(): boolean {
        return !this.attributes_name?.includes(UserPermission.CLIENT);
    }

    protected override __build: { [path: string]: new (data: any) => any; } = {
        customer: Customer,
        'populated.marques': Marque
    };

    get lang(): string {
        return this.language || USER_LANGUAGES.fr.key;
    }

    _id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullname: string;
    email: string;
    attributes_name: string[];
    permissions: any[];
    customer?: Customer;
    marque?: string;
    marques: string[];  
    scope_name?: string[];
    language?: string;
    populated?: { marques: Marque[]; } | undefined;

    constructor(data: Partial<User>) {
        super(data);
        this.init(data);
    }
}
